import React, { useEffect } from "react";
import AppHeader from "../components/reusable/header";
import Footer from "../components/reusable/footer";
import { RiShieldKeyholeLine, RiGlobalLine, RiTeamLine, RiBarChartLine, RiCustomerService2Line, RiServerLine } from "react-icons/ri";
import {
  EnterpriseMainDiv,
  EnterpriseHeroSection,
  ButtonContainer,
  PrimaryButton,
  SecondaryButton,
  Section,
  SectionTitle,
  FeatureGrid,
  FeatureCard,
  ContactSection
} from "../styles/enterprise";

const Enterprise = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: <RiShieldKeyholeLine />,
      title: "Enterprise-Grade Security",
      description: "SOC 2 Type II compliance, end-to-end encryption, and advanced access controls to keep your data secure."
    },
    {
      icon: <RiGlobalLine />,
      title: "Scalable Infrastructure",
      description: "Built to handle millions of requests with 99.99% uptime SLA and dedicated processing resources."
    },
    {
      icon: <RiTeamLine />,
      title: "Team Management",
      description: "Centralized billing, SSO integration, and role-based access control for seamless team administration."
    },
    {
      icon: <RiBarChartLine />,
      title: "Advanced Analytics",
      description: "Deep insights into usage patterns, performance metrics, and ROI tracking for your organization."
    },
    {
      icon: <RiCustomerService2Line />,
      title: "Dedicated Support",
      description: "24/7 priority support, dedicated account manager, and personalized onboarding for your team."
    },
    {
      icon: <RiServerLine />,
      title: "Private Deployment",
      description: "Option for on-premise or VPC deployment to meet strict data residency and compliance requirements."
    }
  ];

  return (
    <EnterpriseMainDiv>
      <AppHeader
        hideContact={false}
        logo={"/images/sixthWhiteIcon.png"}
        top="0.5rem"
        width="10rem"
        mobileWidth="8rem"
      />
      
      <EnterpriseHeroSection>
        <h1>AI Infrastructure for the<br />Modern Enterprise</h1>
        <p>
          Empower your organization with Sixth's secure, scalable, and intelligent AI platform. 
          Built for teams that demand performance, compliance, and control.
        </p>
        <ButtonContainer>
          <PrimaryButton onClick={() => window.location.href = "mailto:ope@trysixth.com"}>
            Contact Sales
          </PrimaryButton>
          <SecondaryButton onClick={() => window.open("https://calendly.com/ope-trysixth/30min", "_blank")}>
            Schedule Demo
          </SecondaryButton>
        </ButtonContainer>
      </EnterpriseHeroSection>

      <Section>
        <SectionTitle>Everything you need to scale</SectionTitle>
        <FeatureGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <div className="icon-wrapper">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </FeatureCard>
          ))}
        </FeatureGrid>
      </Section>

      <ContactSection>
        <h2>Ready to transform your business?</h2>
        <p>
          Join leading organizations that trust Sixth to power their AI initiatives. 
          Let's discuss how we can help you achieve your goals.
        </p>
        <ButtonContainer>
          <PrimaryButton onClick={() => window.location.href = "mailto:ope@trysixth.com"}>
            Contact Sales
          </PrimaryButton>
        </ButtonContainer>
      </ContactSection>

      <Footer />
    </EnterpriseMainDiv>
  );
};

export default Enterprise;
